import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import getBaseComponent from 'utils/framework/getBaseComponent';
import getStyledComponent from 'utils/framework/getStyledComponent';
import {
    compose, border, space, system
} from 'styled-system';
import theme from 'style/theme';

const display = system({ display: { property: 'display' } });

const StyledDiv = getStyledComponent({
    InnerComp: getBaseComponent({ elementType: 'div' }),
    styledProps: [compose(display, border, space), props => props.css]
});

function Divider({ thick, color = 'divider', height = 1, ...props }) {
    let borderBottom = height;
    let borderColor = color;

    if (thick) {
        borderBottom = 3;
        borderColor = 'nearWhite';
    }

    return (
        <StyledDiv
            borderBottom={borderBottom}
            borderColor={borderColor}
            theme={theme}
            {...props}
        />
    );
}

export default wrapFunctionalComponent(Divider, 'Divider');
